interface BuildAffiliateLinkParams {
  baseUrl?: string;
  gameSlug: string;
  campaignSlug: string;
  accountHandle: string;
}

export function buildAffiliateLink({
  baseUrl =
    import.meta.env.VITE_AFFILIATE_BASE_URL ?? import.meta.env.NEXT_PUBLIC_AFFILIATE_BASE_URL ??
    "https://play.lemontreestudio.games",
  gameSlug,
  campaignSlug,
  accountHandle,
}: BuildAffiliateLinkParams) {
  const normalizedHandle = accountHandle.replace(/[^a-zA-Z0-9-]/g, "").toLowerCase();
  // Use campaign tags format: ?campaign=slug&ref=handle
  return `${baseUrl.replace(/\/$/, "")}/${gameSlug}?campaign=${campaignSlug}&ref=${normalizedHandle}`;
}
